import WarpElement from "@warp-ds/elements-core";
import { CategoryWithLink } from "../../models/category.js";
import { css, html } from "lit";
import { largeNumberFormatter } from "../../utils/formatters.js";
import { Brand, Subvertical } from "../../constants.js";
import { trackClickEvent } from "../tracking.js";
import { TrackingEventMap } from "../../models/trackingEvent.js";
import { getLocaleByBrand } from "../../utils/getLocaleByBrand.js";
import { trackExperiment } from "@finn-no/pulse-experiment-tracking";

class Categories extends WarpElement {
    declare categories: Array<CategoryWithLink>;
    declare subvertical: Subvertical;
    declare brand: Brand;
    declare trackingEventMap: TrackingEventMap;
    declare searchPodletExperimentVariant: string; // todo: remove after experiment

    static properties = {
        categories: { type: Array },
        subvertical: { type: String },
        brand: { type: String },
        trackingEventMap: { type: Object },
        searchPodletExperimentVariant: { type: String }, // todo: remove after experiment
    };

    constructor() {
        super();
    }

    connectedCallback() {
        // todo: remove after experiment
        if (this.searchPodletExperimentVariant !== "disabled") {
            trackExperiment("search.mobility.newfrontier-on-frontpage", this.searchPodletExperimentVariant);
        }
    }

    static styles = [
        WarpElement.styles,
        css`
            .list-wrapper {
                display: grid;
                grid-template-columns: repeat(3, 156px);
            }

            @css-placeholder-pTgDLL;
        `,
    ];

    render() {
        return html`<section class="flex flex-col gap-y-40 md:flex-row flex-wrap">
            <div class="flex-1">
                <div class="gap-x-56 gap-y-24 lt-md:grid-cols-2 grid-rows-auto list-wrapper">
                    ${(this.categories ?? []).map(
                        (category) =>
                            html`<a
                                href=${category.link}
                                class="flex flex-col gap-4 hover:s-text"
                                @click="${() => trackClickEvent(category.trackingEvent)}"
                            >
                                <span class="s-text font-bold">${category.title}</span>
                                ${category.hits
                                    ? html`<span class="s-text-subtle text-caption" aria-hidden="false"
                                          >${largeNumberFormatter(category.hits, getLocaleByBrand(this.brand))}</span
                                      >`
                                    : ""}
                            </a>`,
                    )}
                </div>
            </div>

            <mfp-sell-mobility-vehicle
                class="w-full max-w-full md:w-[304px] min-w-[200px]"
                brand="${this.brand}"
                subvertical="${this.subvertical}"
                trackingEventMap="${JSON.stringify(this.trackingEventMap)}"
            ></mfp-sell-mobility-vehicle>
        </section>`;
    }
}

customElements.define("category-list", Categories);
